import { CrudStoreItemScout } from 'legacy/lut/classes/models/CrudStoreItemScout'
import { IFormPartnerCSI } from 'legacy/lut/classes/models/IFormMyPartnerCSI'
import { IFormSearchCodes } from 'legacy/lut/classes/models/IFormSearchCodes'

import { Crud } from 'core/types/Crud'
import { CrudInnerStorageFetcher } from 'core/types/CrudInnerStorageFetcher'
import { CrudStore } from 'core/types/crudStore'

import { CrudConnectorsScout } from './CrudConnectorsScout'

class InitializationServiceScout {
  public init = () => {
    CrudStore.add(
      new Crud<IFormSearchCodes>({
        fetcher: new CrudInnerStorageFetcher<IFormSearchCodes>('EntryID', {
          formId: 577,
          code: 'WW_PartnerFlags',
        }),
        keyField: 'EntryID',
      }),
      CrudStoreItemScout.WW_PartnerFlags
    )
    CrudStore.add(
      new Crud<IFormSearchCodes>({
        fetcher: new CrudInnerStorageFetcher<IFormSearchCodes>('EntryID', {
          formId: 577,
          code: 'WW_PartnerFlags_Inactive',
        }),
        keyField: 'EntryID',
      }),
      CrudStoreItemScout.WW_PartnerFlags_Inactive
    )
    CrudStore.add(
      new Crud<IFormPartnerCSI>({
        fetcher: new CrudInnerStorageFetcher<IFormPartnerCSI>('EntryId', {
          formId: 423,
          code: 'PartnerListCSI',
        }),
        keyField: 'EntryId',
        connectorUpdateFn: CrudConnectorsScout.updatePartnerListCSI,
        connectorCreateFn: CrudConnectorsScout.updatePartnerListCSI,
      }),
      CrudStoreItemScout.PartnerListCSI
    )
    CrudStore.add(
      new Crud<IFormSearchCodes>({
        fetcher: new CrudInnerStorageFetcher<IFormSearchCodes>('EntryID', {
          formId: 577,
          code: 'WW_PartnerFlags_DateFormat',
        }),
        keyField: 'EntryID',
      }),
      CrudStoreItemScout.WW_PartnerFlags_DateFormat
    )
  }
}

export default new InitializationServiceScout()
